import type { UserOut } from "@/types/api";

export function displayNameFor(user: UserOut | null | undefined, fallback = "User"): string {
  return user?.display_name?.trim() || user?.email?.trim() || fallback;
}

export function initialsFor(name: string): string {
  const s = name.trim();
  if (!s) return "?";
  const parts = s.split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return s.slice(0, 2).toUpperCase();
}
